import { Box } from 'rebass/styled-components'

interface IConversationStatusCardProps {
  status: string
}

export const ConversationStatusCard: React.FC<IConversationStatusCardProps> = ({ status }) => {
  const getBackground = () => {
    if (!status) return ''
    switch (status.toUpperCase()) {
      case 'CLOSED':
        return '#748494'
      case 'ACTIVE':
        return '#56c288'
      case 'PENDING':
        return '#ce7129'

      default:
        return ''
    }
  }

  return (
    <Box ml={3}
      sx={{
        color: 'white',
        bg: getBackground(),
        px: 3,
        py: '1px',
        borderRadius: 4,
        fontSize: '12px',
        display: 'flex',
        alignItems: 'center',
        fontWeight: 500
      }}>
      {status.toUpperCase()}
    </Box>);
}